import {
  Table,
  Button,
  Switch,
  Popconfirm,
  Tooltip,
  Avatar,
  Input,
  notification,
  Spin,
} from "antd";
import * as React from "react";
import { get } from "lodash";
import { getAllFaq } from "../../Graphs/Faq/listFaq";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { UserOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { deleteFaq } from "../../Graphs/Faq/deleteFaq";
import { changeStatus } from "../../Graphs/Faq/changeStatus";
import { editFaq } from "../../Graphs/Faq/editFaq";
import { searchFaq } from "../../Graphs/Faq/searchFaq";
import { EditModal } from "./EditModal";
import { checkPermission } from "../AdminUser/CheckAdminPermission";

var moment = require("moment");

const BASE_IMAGE_URL =
  "https://s3.us-east-2.amazonaws.com/cerebrus-consulting/bloodman_user_media/";

class FaqRecordsTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      isLoading: true,
      startIndex: 0,
      limitNumber: 10,
      pagination: {
        pageSize: 10,
        current: 1,
      },
    };
    this.handleTableChange = this.handleTableChange.bind(this);
    this.getLimitedFaq = this.getLimitedFaq.bind(this);
  }

  async componentDidMount() {
    const { loginUserData } = this.props;

    // Check if user has any permission (edit, delete, view)
    const canEdit = checkPermission(loginUserData, "users", "edit");
    const canDelete = checkPermission(loginUserData, "users", "delete");
    const canView = checkPermission(loginUserData, "users", "view");

    // Remove "Actions" column if no permissions are granted
    if (!canEdit && !canDelete && !canView) {
      this.columns = this.columns.filter((item) => item.key !== "action");
    }

    // Keep existing state logic
    this.setState({
      data: this.props.data,
      isLoading: false,
      userSelectedData: null,
    });
  }

  modalRef;

  async getLimitedFaq(pagination) {
    const { searchText } = this.props;
    console.log("tempCounter && counter --> ", this.tempCounter, this.counter);
    const start =
      pagination.current * pagination.pageSize - pagination.pageSize;
    const end = pagination.pageSize;

    this.setState(
      {
        isLoading: true,
        startIndex: start,
        limitNumber: end,
      },
      async () => {
        if (searchText != null && searchText !== "") {
          //get search text props from redux store
          this.listSearchFaqData(start, end);
        } else {
          //call normal user Data
          this.listFaqData(start, end);
        }
      }
    );
  }

  listSearchFaqData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListFaqData,
        setListFaqDataTotal,
        searchText,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let faqData = await searchFaq(
        authToken,
        searchText,
        start,
        end,
        course_id
      );

      if (faqData.status === 200) {
        //set user Data
        await setListFaqData(faqData.data.FAQs);
        await setListFaqDataTotal(faqData.total);

        this.setState({
          isLoading: false,
          data: faqData.data.FAQs,
        });
      } else if (faqData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list search user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  listFaqData = async (start, end) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        setListFaqData,
        setListFaqDataTotal,
        course_id,
      } = this.props;
      this.setState({
        isLoading: true,
      });

      let faqData = await getAllFaq(authToken, start, end, course_id);

      if (faqData.status === 200) {
        //set user Data
        // await setListFaqData(faqData.data.docs);
        await setListFaqData(faqData.data.FAQs);
        await setListFaqDataTotal(faqData.total);
      } else if (faqData.status == 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      console.log("!!!!!!!list user Data printed here", e);
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  showModal(item) {
    this.setState(
      {
        faqSelectedData: item,
        // isOpen: true
      },
      () => {
        this.modalRef.show();
      }
    );
  }

  handleDetailsModalclose() {
    this.setState({
      faqSelectedData: null,
    });
  }

  counter = 0;
  tempCounter = 0;
  columns = [
    {
      title: "Sr. No.",
      width: 150,
      key: "serial_number",
      render: (text, item, index) => {
        return (
          <div>
            <span>{++index + this.tempCounter}</span>
          </div>
        );
      },
    },
    {
      title: "Question",
      width: 150,
      key: "question",
      render: (text, item, index) => {
        console.log("user record --> ", item);
        return (
          <div>
            <strong>
              <Tooltip placement="bottom" title="Question">
                <div>{item.question ? item.question : "-"}</div>
              </Tooltip>
            </strong>
          </div>
        );
      },
    },
    // {
    //   title: "Course",
    //   width: 150,
    //   key: "course",
    //   render: (text, item, index) => {
    //     console.log("user record --> ", item);
    //     return (
    //       <div>
    //         <strong>
    //           <Tooltip placement="bottom" title="Course">
    //             <div>{item.courseData && item.courseData[0] && item.courseData[0].name ? item.courseData[0].name : "-"}</div>
    //           </Tooltip>
    //         </strong>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   title: "Active",
    //   width: 100,
    //   key: "is_active",
    //   render: (text, item, index) => {
    //     return (
    //       <div>
    //         {item.is_active != null ? (
    //           <Tooltip placement="bottom" title="Faq Activation">
    //             {
    //               <Switch checked={item.is_active} style={{ backgroundColor: item.is_active ? this.props.primaryColor : "#bababa", }} onChange={this.onChange.bind(this, item)} />
    //             }
    //           </Tooltip>
    //         ) : (
    //           "-"
    //         )}
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Actions",
      width: 130,
      key: "action",
      render: (text, item, index) => {
        const { loginUserData } = this.props;
        const canEdit = checkPermission(loginUserData, "users", "edit");
        const canDelete = checkPermission(loginUserData, "users", "delete");
        return (
          <div style={{ display: "inline-block", width: "100%" }}>
            {canEdit && (
              <div mr="5px" style={{ float: "left" }}>
                <Tooltip placement="bottom" title="Edit">
                  <Button
                    shape="circle"
                    icon={<EditOutlined />}
                    onClick={() => {
                      this.showModal(item);
                    }}
                  />
                </Tooltip>
              </div>
            )}
            {canDelete && (
              <div
                ml="15px"
                mr="5px"
                style={{ float: "left", marginLeft: "10px" }}
              >
                <Tooltip placement="bottom" title="Delete">
                  <Popconfirm
                    onConfirm={this.deleteFaqData.bind(this, item)}
                    title="Are you sure you want to delete FAQ?"
                  >
                    <Button shape="circle" icon={<DeleteOutlined />} />
                  </Popconfirm>
                </Tooltip>
              </div>
            )}
          </div>
        );
      },
    },
  ];

  async deleteFaqData(item) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
        course_id,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let deleteData = await deleteFaq(authToken, item._id, course_id);

      if (deleteData.status === 200) {
        notification["success"]({
          message: "Delete Faq",
          description: "Successfully deleted",
        });

        /*if (searchText != null && searchText !== "") {
          this.listSearchFaqData(startIndex, limitNumber);
          return;
        } */
        this.listFaqData(startIndex, limitNumber);
      } else if (deleteData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Delete Faq",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  async onChange(item, checked) {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await changeStatus(authToken, item._id, checked);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Change Faq Status",
          description: "Successfully changed status",
        });
        if (searchText != null && searchText !== "") {
          this.listSearchFaqData(startIndex, limitNumber);
          return;
        }
        this.listFaqData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (err) {
      notification["error"]({
        message: "Change Faq Status",
        description: err,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  }

  editSubmit = async (faqObject) => {
    try {
      const {
        authToken,
        history,
        setLoginFlag,
        setUserData,
        setUserToken,
        searchText,
      } = this.props;
      const { startIndex, limitNumber } = this.state;

      this.setState({
        isLoading: true,
      });
      let statusData = await editFaq(authToken, faqObject);
      if (statusData.status === 200) {
        notification["success"]({
          message: "Edit Faq Status",
          description: "Successfully edited",
        });
        this.handleDetailsModalclose();
        if (searchText != null && searchText !== "") {
          this.listSearchFaqData(startIndex, limitNumber);
          return;
        }
        this.listFaqData(startIndex, limitNumber);
      } else if (statusData.status === 401) {
        await setLoginFlag(false);
        await setUserData(null);
        await setUserToken(null);
        history.push(`${process.env.PUBLIC_URL}/login`);
      }
    } catch (e) {
      notification["error"]({
        message: "Edit Faq",
        description: e,
      });
    } finally {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleTableChange(pagination, filters) {
    console.log("outer onchange iusers", pagination);
    this.setState(
      {
        pagination,
      },
      () => this.getLimitedFaq(pagination)
    );
  }

  render() {
    const { isLoading, data } = this.state;
    const { listFaqData, listFaqDataTotal, searchLoader } = this.props;

    return isLoading || searchLoader ? (
      <div style={{ marginLeft: "20px" }}>
        <Spin
          size="large"
          style={{ marginLeft: "480px", marginTop: "130px" }}
        />
      </div>
    ) : (
      <div style={{ overflowX: "auto" }}>
        <Table
          loading={this.state.isLoading}
          rowKey={(record) => record._id}
          columns={this.columns}
          size={"small"}
          // dataSource={this.state.data}
          dataSource={listFaqData}
          pagination={{
            total: listFaqDataTotal,
            showSizeChanger: true,
            pageSize: this.state.pagination.pageSize,
            current: this.state.pagination.current,
            pageSizeOptions: ["1", "10", "25", "50", "100"],
            onChange: (e) => {
              console.log("onChanges pagination");
              // e - 1
              //   ? (this.counter = this.tempCounter =
              //       (e - 1) * this.state.pagination.pageSize)
              //   : ((this.counter = 0), (this.tempCounter = 0));
              if (e - 1) {
                this.counter = this.tempCounter =
                  (e - 1) * this.state.pagination.pageSize;
                return;
              }

              this.counter = 0;
              this.tempCounter = 0;
            },
          }}
          onChange={this.handleTableChange}
        />
        {this.state.faqSelectedData ? (
          <EditModal
            admin={false}
            refx={(e) => (this.modalRef = e)}
            onClose={this.handleDetailsModalclose.bind(this)}
            faqSelectedData={this.state.faqSelectedData}
            course_id={this.props.course_id}
            onSubmit={this.editSubmit}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.auth.authToken,
  listFaqData: state.faq.listFaqData,
  listFaqDataTotal: state.faq.listFaqDataTotal,
  searchLoader: state.auth.searchLoader,
  searchText: state.auth.searchText,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setLoginFlag: (flag) => {
      dispatch({
        type: "SET_LOGIN_FLAG",
        flag: flag,
      });
    },
    setUserData: (userData) => {
      dispatch({
        type: "SET_USER_DATA",
        userData: userData,
      });
    },
    setUserToken: (authToken) => {
      dispatch({
        type: "SET_USER_AUTHTOKEN",
        authToken: authToken,
      });
    },
    setListFaqData: (listFaqData) => {
      dispatch({
        type: "SET_LIST_FAQ_DATA",
        listFaqData: listFaqData,
      });
    },
    setListFaqDataTotal: (listFaqDataTotal) => {
      dispatch({
        type: "SET_LIST_FAQ_DATA_TOTAL",
        listFaqDataTotal: listFaqDataTotal,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FaqRecordsTable));
